<template lang="pug">
  .lottery-error-block-container
    img.error-img(
      src="https://m.hellobike.com/resource/gallery/833/awi91J3Kp9.png"
      alt=""
    )
    .error-text 加载异常，请稍后再试
    .error-btn(@click="handleRefresh") 刷新
</template>

<script>
export default {
  name: 'LotteryErrorBlock',
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    // 刷新
    handleRefresh() {
      this.$emit('refresh');
    },
  },
};
</script>

<style lang="less" scoped>
.lottery-error-block-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.04rem 0 0.6rem;
  width: 100%;

  .error-img {
    width: 1.5rem;
    height: 1.18rem;
    vertical-align: bottom;
  }

  .error-text {
    margin-top: 0.06rem;
    font-size: 0.14rem;
    line-height: 0.2rem;
    color: #242729;
  }

  .error-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.16rem;
    width: 0.8rem;
    height: 0.32rem;
    border-radius: 0.16rem;
    background-color: #853828;
    font-size: 0.14rem;
    line-height: normal;
    color: #fff;
  }
}
</style>
